import { useEffect } from "react";

// HubSpot tracking script + chat widget, for signed-in pages only.

const HUBSPOT_SCRIPT_ID = "hs-script-loader";
const HUBSPOT_SCRIPT_SRC = "//js-na2.hs-scripts.com/245723760.js?businessUnitId=46668747";

declare global {
  interface Window {
    HubSpotConversations?: { widget: { load: () => void; remove: () => void } };
    hsConversationsOnReady?: Array<() => void>;
  }
}

// Logout is a client-side navigate, so the widget has to be removed by hand,
// including when it finishes loading after the user has already left.
let active = false;

export function useHubSpotScript(): void {
  useEffect(() => {
    active = true;

    if (!document.getElementById(HUBSPOT_SCRIPT_ID)) {
      window.hsConversationsOnReady = [
        () => {
          if (!active) window.HubSpotConversations?.widget.remove();
        },
      ];

      const script = document.createElement("script");
      script.src = HUBSPOT_SCRIPT_SRC;
      script.type = "text/javascript";
      script.async = true;
      script.defer = true;
      script.id = HUBSPOT_SCRIPT_ID;
      script.onerror = () => {
        console.error("HubSpot script failed to load");
      };

      document.head.appendChild(script);
    } else {
      window.HubSpotConversations?.widget.load();
    }

    return () => {
      active = false;
      window.HubSpotConversations?.widget.remove();
    };
  }, []);
}
